import { render, staticRenderFns } from "./LibraryLoanableOverview.vue?vue&type=template&id=4895f85a&scoped=true"
import script from "./LibraryLoanableOverview.vue?vue&type=script&lang=js"
export * from "./LibraryLoanableOverview.vue?vue&type=script&lang=js"
import style0 from "./LibraryLoanableOverview.vue?vue&type=style&index=0&id=4895f85a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895f85a",
  null
  
)

export default component.exports